// Relay.jsx
import React, { useEffect } from 'react'
// 引入全局 SCSS 文件
import './Relay.scss'
import { LoadingOutlined } from '@ant-design/icons'
import { getLoginByTicketApi } from 'api'
import { useContextConsumer } from 'context/loginAuthProvider'
import { clearUrlTicket, setStroage } from 'utils'
import { persistor } from 'redux/store'

const Relay = () => {
    const { setToken, logout } = useContextConsumer() // 登录权鉴
    const searchParams = new URLSearchParams(window.location.search)
    // 2. 提取 ticket 参数（参数名与 URL 中的保持一致，如 ?ticket=xxx）
    const ticket = searchParams.get('ticket') || ''

    /* 手动修改 url 处理 */
    useEffect(async () => {
        if (!ticket) return
        try {
            await localStorage.clear()
            const res = await getLoginByTicketApi(ticket)
            setToken(res?.data?.data?.token)
            setStroage('token', res?.data?.data?.token)
            setStroage('ticket', ticket)
            clearUrlTicket()
            window.location.reload(true)
        } catch (error) {
            clearUrlTicket()
            window.location.reload(false)
            await persistor.purge() // 清除 redux 持久存储内容
            logout()
        }
    }, [])

    return (
        // 绑定全局样式类名
        <div className='relayContainer'>
            <span className='relayText'>
                <LoadingOutlined
                    style={{
                        fontSize: '32px', // 核心：设置字体大小，数值越大图标越大（默认一般16px）
                        color: 'black',
                    }}
                />
            </span>
        </div>
    )
}

export default Relay
